import ButtonStd from "./ButtonStd";
import ButtonLoadMore from "./ButtonLoadMore";
import ButtonText from "./ButtonText";
import ButtonTextNoLink from "./ButtonTextNoLink";
import ButtonArrowRight from "./ButtonArrowRight";
import ButtonBackEvents from "./ButtonBackEvents";

export {
  ButtonStd,
  ButtonLoadMore,
  ButtonText,
  ButtonTextNoLink,
  ButtonArrowRight,
  ButtonBackEvents
};



// WEBPACK FOOTER //
// ./src/components/Buttons/index.js